import { I18n } from '@boschebike/ebds-js';
import { termsOfUseRoutes } from '../../config/router';
import { Page } from '../../components';
import { useContent } from '../../hooks/use-content';

export const TermsOfUseAuPage = () => {
  const content: I18n = useContent('en-AU');
  const links = termsOfUseRoutes(content, { isDPASupported: false });

  return (
    <Page
      links={links}
      enforcedTabId={links[0].id}
    >
      <div
        dangerouslySetInnerHTML={{
          __html: content.t('portal.termsOfUse'),
        }}
      />
    </Page>
  );
};
